import { UserProvider } from "./Context/useAuth"; 
import { useEffect } from 'react';
import { useNavigate,useLocation   } from 'react-router-dom'; 
import {LoadingProvider} from './Context/LoadingContext';
import GlobalLoader from './Components/GlobalLoader';
import AppContent from './Context/AppContent';
import {
  NotificationProvider
} from "./notifications/NotificationContext";
 import {Toaster} from "react-hot-toast";
 
//export default App;
function App() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/branches");
    }
  }, [navigate, location.pathname]);

  return (
    <>
<NotificationProvider> 
<LoadingProvider> 
<UserProvider> 
<AppContent /> 
<GlobalLoader /> 
<Toaster 
position="top-center" 
toastOptions={{ 
duration: 3000, 
}} 
/> 
</UserProvider> 
</LoadingProvider> 
</NotificationProvider>

      {/* <NotificationProvider>
        <LoadingProvider>
          <UserProvider>
            <SessionManager />

            <Outlet />

            <Toaster
              position="top-center"
              toastOptions={{
                duration: 3000,
              }}
            />
   {showSessionDialog && (
        <SessionModal
            approveAction={continueSession}
            cancelAction={logout}
            btnApproveTitle="إرسال البريد"
            btnCancelTitle="الغاء"
            title="تاكيد إرسال البريد الإلكتروني"
            popupType={1}
            size="4xl"
            btnIcon="send"
          />
      )}
            <GlobalLoader />
          </UserProvider>
        </LoadingProvider>
      </NotificationProvider> */}
    </>
  );
}

export default App;

 